import styled from 'styled-components';

export const RoomDetailsGrid = styled.div`
  grid-template-columns: 1fr;
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  display: grid;
  margin-top: 10px;
`;
